import { useShallow } from "zustand/react/shallow";
import { useBuilderStore } from "../../store/useBuilderStore";

export interface BuilderPageState {
	market: ReturnType<typeof useBuilderStore.getState>["market"];
	locationMode: ReturnType<typeof useBuilderStore.getState>["locationMode"];
	climateProfile: ReturnType<typeof useBuilderStore.getState>["climateProfile"];
	dimensions: ReturnType<typeof useBuilderStore.getState>["dimensions"];
	partitionSplit: ReturnType<typeof useBuilderStore.getState>["partitionSplit"];
	twoRoomConfig: ReturnType<typeof useBuilderStore.getState>["twoRoomConfig"];
	timeOfDay: ReturnType<typeof useBuilderStore.getState>["timeOfDay"];
	rotationDeg: ReturnType<typeof useBuilderStore.getState>["rotationDeg"];
	wizardCapacityHint: ReturnType<
		typeof useBuilderStore.getState
	>["wizardCapacityHint"];
	visibility: ReturnType<typeof useBuilderStore.getState>["visibility"];
	openings: ReturnType<typeof useBuilderStore.getState>["openings"];
	deckConfig: ReturnType<typeof useBuilderStore.getState>["deckConfig"];
	roofConfig: ReturnType<typeof useBuilderStore.getState>["roofConfig"];
	buildProgress: ReturnType<typeof useBuilderStore.getState>["buildProgress"];
	thermalInputs: ReturnType<typeof useBuilderStore.getState>["thermalInputs"];
	siteConditions: ReturnType<typeof useBuilderStore.getState>["siteConditions"];
	interiorLayout: ReturnType<typeof useBuilderStore.getState>["interiorLayout"];
	finishes: ReturnType<typeof useBuilderStore.getState>["finishes"];
	setFinishes: ReturnType<typeof useBuilderStore.getState>["setFinishes"];
	wallHeightM: ReturnType<typeof useBuilderStore.getState>["wallHeightM"];
	setWallHeightM: ReturnType<typeof useBuilderStore.getState>["setWallHeightM"];
	indoorRoom: ReturnType<typeof useBuilderStore.getState>["indoorRoom"];
	setIndoorRoom: ReturnType<typeof useBuilderStore.getState>["setIndoorRoom"];
	projectName: ReturnType<typeof useBuilderStore.getState>["projectName"];
	postalCode: ReturnType<typeof useBuilderStore.getState>["postalCode"];
	saving: ReturnType<typeof useBuilderStore.getState>["saving"];
	saveStatus: ReturnType<typeof useBuilderStore.getState>["saveStatus"];
	loadingDesign: ReturnType<typeof useBuilderStore.getState>["loadingDesign"];
	setDimensions: ReturnType<typeof useBuilderStore.getState>["setDimensions"];
	setPartitionSplit: ReturnType<
		typeof useBuilderStore.getState
	>["setPartitionSplit"];
	setTwoRoomConfig: ReturnType<
		typeof useBuilderStore.getState
	>["setTwoRoomConfig"];
	setTwoRoomPreset: ReturnType<
		typeof useBuilderStore.getState
	>["setTwoRoomPreset"];
	setTimeOfDay: ReturnType<typeof useBuilderStore.getState>["setTimeOfDay"];
	setRotationDeg: ReturnType<typeof useBuilderStore.getState>["setRotationDeg"];
	stepRotation: ReturnType<typeof useBuilderStore.getState>["stepRotation"];
	setVisibility: ReturnType<typeof useBuilderStore.getState>["setVisibility"];
	setOpenings: ReturnType<typeof useBuilderStore.getState>["setOpenings"];
	setDeckConfig: ReturnType<typeof useBuilderStore.getState>["setDeckConfig"];
	setRoofConfig: ReturnType<typeof useBuilderStore.getState>["setRoofConfig"];
	setBuildProgress: ReturnType<
		typeof useBuilderStore.getState
	>["setBuildProgress"];
	setThermalInputs: ReturnType<
		typeof useBuilderStore.getState
	>["setThermalInputs"];
	setSiteConditions: ReturnType<
		typeof useBuilderStore.getState
	>["setSiteConditions"];
	setInteriorLayout: ReturnType<
		typeof useBuilderStore.getState
	>["setInteriorLayout"];
	setProjectName: ReturnType<typeof useBuilderStore.getState>["setProjectName"];
	setLocationMode: ReturnType<
		typeof useBuilderStore.getState
	>["setLocationMode"];
	setClimateProfile: ReturnType<
		typeof useBuilderStore.getState
	>["setClimateProfile"];
	setPostalCode: ReturnType<typeof useBuilderStore.getState>["setPostalCode"];
	resetToDefaults: ReturnType<
		typeof useBuilderStore.getState
	>["resetToDefaults"];
	loadTemplate: ReturnType<typeof useBuilderStore.getState>["loadTemplate"];
}

export function useBuilderPageState(): BuilderPageState {
	return useBuilderStore(
		useShallow((state) => ({
			dimensions: state.dimensions,
			market: state.market,
			locationMode: state.locationMode,
			climateProfile: state.climateProfile,
			visibility: state.visibility,
			openings: state.openings,
			partitionSplit: state.partitionSplit,
			twoRoomConfig: state.twoRoomConfig,
			timeOfDay: state.timeOfDay,
			rotationDeg: state.rotationDeg,
			wizardCapacityHint: state.wizardCapacityHint,
			deckConfig: state.deckConfig,
			roofConfig: state.roofConfig,
			buildProgress: state.buildProgress,
			thermalInputs: state.thermalInputs,
			siteConditions: state.siteConditions,
			interiorLayout: state.interiorLayout,
			finishes: state.finishes,
			setFinishes: state.setFinishes,
			wallHeightM: state.wallHeightM,
			setWallHeightM: state.setWallHeightM,
			indoorRoom: state.indoorRoom,
			setIndoorRoom: state.setIndoorRoom,
			projectName: state.projectName,
			postalCode: state.postalCode,
			saving: state.saving,
			saveStatus: state.saveStatus,
			loadingDesign: state.loadingDesign,
			setDimensions: state.setDimensions,
			setPartitionSplit: state.setPartitionSplit,
			setTwoRoomConfig: state.setTwoRoomConfig,
			setTwoRoomPreset: state.setTwoRoomPreset,
			setTimeOfDay: state.setTimeOfDay,
			setRotationDeg: state.setRotationDeg,
			stepRotation: state.stepRotation,
			setVisibility: state.setVisibility,
			setOpenings: state.setOpenings,
			setDeckConfig: state.setDeckConfig,
			setRoofConfig: state.setRoofConfig,
			setBuildProgress: state.setBuildProgress,
			setThermalInputs: state.setThermalInputs,
			setSiteConditions: state.setSiteConditions,
			setInteriorLayout: state.setInteriorLayout,
			setProjectName: state.setProjectName,
			setLocationMode: state.setLocationMode,
			setClimateProfile: state.setClimateProfile,
			setPostalCode: state.setPostalCode,
			resetToDefaults: state.resetToDefaults,
			loadTemplate: state.loadTemplate,
		})),
	);
}
